module.exports = __webpack_public_path__ + "img/lifeBlock_8_zh.4bed04b6.png";